<template>
  <div class="app-container">
    <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="dialogVisible = true">添加</el-button>
    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column align="center" label="ID" width="60">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.school.school_name }}
        </template>
      </el-table-column>
      <el-table-column label="板块" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.shop_type == 1" type="primary">食堂美食</el-tag>
          <!-- <el-tag v-else-if="scope.row.shop_type == 2" type="success">舍购</el-tag>
          <el-tag v-else-if="scope.row.shop_type == 3" type="info">夜猫店</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column label="店铺" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.shop_ids.length > 0">共{{scope.row.shop_ids.length}}个店铺</span>
          <span v-else>不限</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="300" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form label-position="left" label-width="110px">
        <el-form-item label="学校">
          <el-select :disabled="this.form.id ? true : false" v-model="form.school_id" placeholder="请选择学校" style="width: 220px">
            <el-option v-for="item in schools" :key="item.id" :label="item.school_name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-if="this.form.school_id" :disabled="this.form.id ? true : false" v-model="form.shop_type" placeholder="请选择板块" style="width: 140px">
            <el-option label="食堂美食" :value="1"></el-option>
            <!-- <el-option label="舍购" :value="2"></el-option>
            <el-option label="夜猫店" :value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="店铺">
          <el-checkbox v-model="unlimit" size="mini" border @click="{}">不限</el-checkbox>
          <el-checkbox-group v-model="form.shop_ids" size="mini">
            <el-checkbox v-for="item in shops" :key="item.id" :label="item.id" border>{{item.shop_name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="form.shop_type == 1" label="提成单价(元)">
          <el-input v-model="form.income_price" type="number" placeholder="提成单价" />
          <span>提成=订单数&times;提成单价(元)，假设订单数=1000，则提成={{income}}</span>
        </el-form-item>
        <el-form-item v-if="form.shop_type != 1" label="提成比例(%)">
          <el-input v-model="form.income_rate" type="number" placeholder="提成比例" />
          <span>提成=总营业额️️&times;提成比例(%)&divide;100，假设营业额=1000，则提成={{income}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      shops: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        saleman_id: ""
      },
      dialogVisible: false,
      btnLoading: false,
      form: {
        id: "",
        saleman_id: "",
        school_id: "",
        shop_type: "",
        shop_ids: [],
        income_rate: 0,
        income_price: 0
      }
    };
  },
  created() {
    if (this.$route.query.id) {
      this.listQuery.saleman_id = parseInt(this.$route.query.id);
    }
    this.getList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["schools", "school_id"]),
    income() {
      return this.form.shop_type == 1
        ? this.form.income_price * 1000
        : this.form.income_rate * 1000 / 100;
    },
    unlimit: {
      get() {
        return this.form.shop_ids.length > 0 ? false : true;
      },
      set() {
        this.form.shop_ids = [];
        return true;
      }
    }
  },
  watch: {
    "form.school_id": {
      handler(newValue, oldValue) {
        if (!this.form.id) {
          this.form.shop_type = "";
        }
      },
      deep: true
    },
    "form.shop_type": {
      handler(newValue, oldValue) {
        if (newValue === "") {
          this.form.shop_ids = [];
          this.shops = [];
        } else if (newValue !== oldValue) {
          if (!this.form.id) {
            this.form.shop_ids = [];
          }
          this.shops = [];
          this.getShopList();
        }
      },
      deep: true
    },
    dialogVisible(newVal, oldVal) {
      // 编辑框一异隐藏，马上清除旧数据
      if (newVal === false) {
        this.form = {
          id: "",
          saleman_id: "",
          school_id: "",
          shop_type: "",
          shop_ids: [],
          income_rate: 0,
          income_price: 0
        };
      }
    }
  },
  methods: {
    getList() {
      this.listQuery.school_id = this.school_id;
      this.listLoading = true;
      request({
        url: "/api/backend/salemanIncome/list",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    getShopList() {
      if (!this.form.shop_type) {
        return;
      }
      request({
        url: "/api/backend/shop/list",
        method: "get",
        params: {
          page: 1,
          limit: 1000000,
          school_id: this.form.school_id,
          shop_type: this.form.shop_type
        }
      }).then(response => {
        this.shops = response.data.data;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleEdit(item) {
      this.form = {
        id: item.id,
        saleman_id: item.saleman_id,
        school_id: item.school_id,
        shop_type: item.shop_type,
        shop_ids: JSON.parse(JSON.stringify(item.shop_ids)),
        income_rate: item.income_rate,
        income_price: item.income_price
      };
      this.dialogVisible = true;
    },
    handleDel(item) {
      this.$confirm("确定要删除该管理员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/salemanIncome/del",
          method: "get",
          params: {
            id: item.id
          }
        }).then(() => {
          // 删除最后一条数据时无数据问题
          this.list.length <= 1 ? this.listQuery.page-- : false;
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
      });
    },
    saveData() {
      this.form.saleman_id = this.listQuery.saleman_id;
      if (!this.form.school_id) {
        this.$message({
          type: "warning",
          message: "请选择学校"
        });
        return;
      }
      if (!this.form.shop_type) {
        this.$message({
          type: "warning",
          message: "请选择板块"
        });
        return;
      }
      if (this.form.shop_type == 1) {
        //外卖
        if (this.form.income_price === "" || this.form.income_price <= 0) {
          this.$message({
            type: "warning",
            message: "请输入正确的提成单价"
          });
          return;
        }
      } else {
        //舍购商城+夜猫店
        if (this.form.income_rate === "" || this.form.income_rate <= 0) {
          this.$message({
            type: "warning",
            message: "请输入正确的提成比例"
          });
          return;
        }
      }
      this.form.shop_id = this.listQuery.shop_id;
      this.btnLoading = true;
      request({
        url: "/api/backend/salemanIncome/save",
        method: "post",
        data: this.form
      })
        .then(() => {
          this.dialogVisible = false;
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.floor-container {
  display: inline-block;
  width: 160px;
  height: 160px;
  margin-right: 25px;
  margin-bottom: 25px;
}
</style>
